<h1 mat-dialog-title>Invoice {{data.invoice?.number}}</h1>
<div mat-dialog-content>
    <p>Are you sure you want to delete invoice {{data.invoice?.number}}?</p>
</div>
<div mat-dialog-actions>
    <button mat-dialog-close mat-button>No Thanks</button>
    <button mat-button cdkFocusInitial (click)="delete()">Delete</button>
</div>
